"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageStreamOut = void 0;
class MessageStreamOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageStreamOut.attributeTypeMap;
    }
}
exports.MessageStreamOut = MessageStreamOut;
MessageStreamOut.discriminator = undefined;
MessageStreamOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<MessageOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=MessageStreamOut.js.map